import { getFunctions, httpsCallable } from 'firebase/functions'
import { deliverAudit } from '@/utils/auditDelivery'

// Coalesce overlapping callbacks. The server deduplicates a session; a later
// authentication in the same tab still gets its own event.
const inFlight = new Map()

/**
 * Record a sign-in outcome via Cloud Function.
 * Bounded delivery. The server deduplicates by verified UID + auth_time + reason.
 *
 * @param {import('firebase/auth').User} user  Firebase Auth user (before signOut)
 * @param {'unregistered'|'pending'|'suspended'|'admitted'} reason
 */
export async function logSignInAttemptForUser(user, reason) {
  if (!user?.uid || !reason) return
  const key = `${user.uid}:${reason}`
  if (inFlight.has(key)) return inFlight.get(key)
  const promise = deliverAudit({
    id: key,
    ownerUid: user.uid,
    send: () => httpsCallable(getFunctions(), 'logSignInAttempt')({ reason })
  }).finally(() => inFlight.delete(key))
  inFlight.set(key, promise)
  return promise
}
